export default __webpack_public_path__ + "static/media/banner-produk.0705735a.jpg";